import { useMutation } from "react-query";
import { updateMedication } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

const useUpdateMedication = (options: Record<string, any> = {}) => {
  const { onSuccess = () => {}, onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    ({ id, payload }: { id: number; payload: Record<string, any> }) =>
      updateMedication(id, payload),
    {
      onSuccess: (response, variables) => {
        showToast({ message: "Medication updated successfully." });
        onSuccess(response, variables);
      },
      onError: (error: any) => {
        const errorMessage = error?.response?.data?.error || "Failed to update medication";
        showToast({ message: errorMessage, errorState: true });
        onError(error);
      },
      ...otherOptions,
    }
  );

  return {
    updateMedicationMutation: mutate,
    isUpdateMedicationLoading: isLoading,
    ...rest,
  };
};

export default useUpdateMedication;
